module.exports = __webpack_public_path__ + "img/public/SiteIcons/calendarIcon.svg?ae1cb92a";